import * as R from 'ramda'
import issuerInstallClient from './issuer/installClient.js'
import testerInstallClient from './tester/installClient.js'

export default R.pipe(issuerInstallClient, testerInstallClient)
